module.exports = {
      id: "sort-usage",
      viewBox: "0 0 6 8",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#sort",
      toString: function () {
        return this.url;
      }
    }